module.exports = __webpack_public_path__ + "static/media/logo-circle-loading.95755e43.png";